import React from 'react';
import { TFinalTest } from '../../../../store/finalTest/types';

interface PropsType {
  test: TFinalTest;
  type: 'success' | 'fail';
}
export const TextMessage: React.FC<PropsType> = ({ test, type }) => {
  if (type === 'success' && test.quantity > 1) {
    return (
      <>
        <h2>Вітаю! Ви пройшли тест успішно!</h2>
        <h3>Ви набрали: «{test.points}» балів.</h3>
      </>
    );
  }
  if (type === 'success') {
    return (
      <>
        <h2>Вітаю! Ви здали тест з першого разу!</h2>
        <h3>Ви набрали «{test.points}» балів.</h3>
      </>
    );
  }
  if (type === 'fail' && test.quantity > 1) {
    return (
      <>
        Тест не здано. Прохідний бал скаладає «{test.minPoints}». Ви набрали «{test.points}» балів. Пройдіть тестування заново.
      </>
    );
  }
  if (type === 'fail') {
    return (
      <>
        Шкода, тест не здано. Ви набрали «{test.points}» балів. Прохідний бал скаладає «{test.minPoints}». Спробуйте ще раз.
      </>
    );
  }
  return null;
};
